import axios from 'axios';

const TOKEN_KEY = 'phocea_session_token';

export const saveSessionToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
};

export const getSessionToken = () => localStorage.getItem(TOKEN_KEY);

export const clearSessionToken = () => localStorage.removeItem(TOKEN_KEY);

// Axios interceptor: attach Bearer token to every request
axios.interceptors.request.use((config) => {
  const token = getSessionToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
